/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * ########################################
 * Trigger Animations when Element comes into Viewport
 * ########################################
 */
jQuery(document).ready(function($) {

    function scrollWaypointInit( items, trigger ) {
        items.each( function() {
            var element = $(this),
                osAnimationClass = element.data("animation"),
                osAnimationDelay = element.attr('data-animation-delay');

            var trigger = ( trigger ) ? trigger : element;

            trigger.waypoint(function() {
                element.addClass(osAnimationClass);
                if (element.attr('data-animation-delay')){
                    element.addClass('delay-'+(osAnimationDelay));
                }
            },{
                triggerOnce: true,
                offset: '100%'
            });
        });
    }

    scrollWaypointInit( $('.animated') );

});

